
<template >
  <footer class="footer">
     <div class="container" >
     <p class="footerText"> Download the Doodhvale app on your phone </p>
      <p class="dv-content"> Available on Both Android and iOS </p>
      <div class="row">
      <div class="col-xs-6 col-sm-3"></div>
        <div class="col-xs-6 col-sm-6">
          <div class="row">
            <div class="appStore"><a  target="_blank" href="https://play.google.com/store/apps/details?id=com.technologies.subtlelabs.doodhvale"><img src='img/google-play.png'></a><a target="_blank"  href="https://apps.apple.com/in/app/doodhvale/id1435706071"><img src='img/appstore.png'></a></div>
          </div>
        </div>
        <div class="col-xs-6 col-sm-3"></div>
      </div>
     <div class="bottom-social footerText">
      <p class="footerText"> Follow Us </p>
						<div class="bottom-social-margin">
							<div class="text-sm-center-bottom">
								<ul class="social-list">
									<li>
									<a target="_blank" href="https://www.instagram.com/doodhvale/">
										<i class="fa fa-instagram"></i>
									</a>
									</li>
									<li>
									<a target="_blank" href="https://twitter.com/doodhvale">
										<i class="fa fa-twitter"></i>
									</a>
									</li>
									<li>
										<a target="_blank" href="https://www.facebook.com/Doodhvale/">
											<i class="fa fa-facebook"></i>
										</a>
									</li>
									<li>
										<a target="_blank" href="https://www.youtube.com/channel/UCvxp2fZIUMX58W7nT1T5_wg">
											<i class="fa fa-youtube"></i>
										</a>
									</li>
								</ul>						
							</div>
							<div class="pd-top-10">
								<div class="dv-content">
									<p class="contact-block__address">B2, Vikas Chamber, D Block, Central Market, Prashant Vihar, Rohini, New Delhi – 110085</p>
									<p class="contact-block__phone">
										<a href="tel:+91-80-10-342-342">+91-80-10-342-342</a></p>
                  <p class="contact-block__phone">
										<a href="mailto:care@doodhvale.com">care@doodhvale.in</a></p>
									<!--p class="contact-block__work-time">7:00 A.M. - 7:00 P.M.</p-->
								</div>
							</div>
						</div>
					</div>
      
    </div>
    <div class="container">
      <div class="copyright">
        &copy; {{ year }}, by doodhvale.com | All rights reserved
      </div>
    </div>
      <template>
    <div>
      <section fxhide="" fxshow.lt-md="" id="bottomMenu" class="showbottomMenu" :class="{ 'hidebottomMenu': !showNavbar }">
            <div id="sm_bottom_menu" class="showbottomMenuBtn" :class="{ 'hidebottomMenuBtn': !showNavbar }" @click="showBottomMenu">
            <b-icon v-if="showNavbar == true " style="height: 30px;width: 30px;" icon="chevron-bar-down"></b-icon>
            <b-icon v-if="showNavbar == false " style="height: 30px;width: 30px;" icon="chevron-bar-up"></b-icon>
            </div>
            <div  class="pd-left-10 pd-rig-10 height-100" fxlayout="row" fxlayoutalign="space-evenly center" style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center space-evenly; align-items: center;">
                <div  fxflex="20" fxlayoutalign="center center" class="flexDiv">
                    <button  class="bottom-nav-btn bottom-nav-btn-selected" @click="()=>$router.push('/')"  tabindex="0">
                        <svg  height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
                            <path  d="M12.59 1.16a2.31 2.31 0 0 0-3.18 0l-9.443 9.435 1.065 1.065L2.75 9.943v9.307A2.25 2.25 0 0 0 5 21.5h12a2.25 2.25 0 0 0 2.25-2.25V9.943l1.718 1.717 1.064-1.065L12.59 1.16zM9.5 20v-5.25h3V20h-3zm8.25-.75A.75.75 0 0 1 17 20h-3v-6.75H8V20H5a.75.75 0 0 1-.75-.75V8.442l6.217-6.225a.75.75 0 0 1 1.066 0l6.217 6.225V19.25z" fill="currentColor" fill-rule="evenodd"></path>
                        </svg>
                        <p  class="margin-0">Home</p>
                    </button>
                </div>
                <div class="bottom-gift-border"></div>
                <div  fxflex="" fxlayoutalign="center center" class="orderNow">
                    <button  class="bottom-nav-notification dv-gift "  @click="()=>$router.push('trialOffer')" tabindex="0">
                        <span class="dv-button-wrapper">
                            <!--svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20pt" height="20pt" viewBox="0 0 20 20" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 15.359375 4.136719 C 15.722656 3.746094 15.949219 3.214844 15.949219 2.628906 C 15.949219 1.40625 14.972656 0.429688 13.789062 0.429688 C 12.890625 0.429688 10.820312 1.773438 9.992188 2.980469 C 9.136719 1.773438 7.074219 0.46875 6.210938 0.46875 C 5.03125 0.46875 4.050781 1.445312 4.050781 2.667969 C 4.050781 3.234375 4.261719 3.746094 4.601562 4.132812 L 0.429688 4.132812 L 0.429688 9.386719 L 1.570312 9.386719 L 1.570312 19.570312 L 18.433594 19.570312 L 18.433594 9.390625 L 19.570312 9.390625 L 19.570312 4.136719 Z M 13.789062 1.246094 C 14.523438 1.246094 15.132812 1.855469 15.132812 2.671875 C 15.132812 3.359375 14.652344 3.949219 14.03125 4.074219 L 10.726562 4.074219 C 10.515625 4.011719 10.449219 3.9375 10.449219 3.894531 C 10.449219 3.199219 12.890625 1.246094 13.789062 1.246094 Z M 6.210938 1.246094 C 7.066406 1.246094 9.550781 3.199219 9.550781 3.894531 C 9.550781 3.957031 9.40625 4.027344 9.300781 4.074219 L 5.972656 4.074219 C 5.351562 3.949219 4.871094 3.359375 4.871094 2.671875 C 4.867188 1.894531 5.480469 1.246094 6.210938 1.246094 Z M 7.554688 18.753906 L 2.382812 18.753906 L 2.382812 9.390625 L 7.554688 9.390625 Z M 7.554688 8.617188 L 1.246094 8.617188 L 1.246094 4.953125 L 7.558594 4.953125 L 7.558594 8.617188 Z M 11.625 18.753906 L 8.367188 18.753906 L 8.367188 4.949219 L 11.625 4.949219 Z M 17.613281 18.753906 L 12.441406 18.753906 L 12.441406 9.390625 L 17.613281 9.390625 Z M 18.75 8.617188 L 12.441406 8.617188 L 12.441406 4.953125 L 18.753906 4.953125 L 18.753906 8.617188 Z M 18.75 8.617188 "/>
                            </g>
                            </svg-->
                            <img width="30pt" height="30pt" src="img/scooter.svg" />
                            <div  id="order-now-text">Order Now</div>
                        </span>
                    </button>
                </div>
                <div fxflex="20" fxlayoutalign="center center" class="flexDiv">
                    <button  aria-haspopup="true" v-popover:popover class="bottom-nav-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15pt" height="15pt" viewBox="0 0 15 15" version="1.1">
                      <g id="surface1">
                      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(45.882353%,45.098039%,45.098039%);fill-opacity:1;" d="M 9.207031 7.367188 C 9.207031 8.382812 8.382812 9.207031 7.367188 9.207031 C 6.347656 9.207031 5.523438 8.382812 5.523438 7.367188 C 5.523438 6.347656 6.347656 5.523438 7.367188 5.523438 C 8.382812 5.523438 9.207031 6.347656 9.207031 7.367188 Z M 9.207031 7.367188 "/>
                      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(45.882353%,45.098039%,45.098039%);fill-opacity:1;" d="M 9.207031 12.890625 C 9.207031 13.90625 8.382812 14.730469 7.367188 14.730469 C 6.347656 14.730469 5.523438 13.90625 5.523438 12.890625 C 5.523438 11.875 6.347656 11.050781 7.367188 11.050781 C 8.382812 11.050781 9.207031 11.875 9.207031 12.890625 Z M 9.207031 12.890625 "/>
                      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(45.882353%,45.098039%,45.098039%);fill-opacity:1;" d="M 9.207031 1.839844 C 9.207031 2.859375 8.382812 3.683594 7.367188 3.683594 C 6.347656 3.683594 5.523438 2.859375 5.523438 1.839844 C 5.523438 0.824219 6.347656 0 7.367188 0 C 8.382812 0 9.207031 0.824219 9.207031 1.839844 Z M 9.207031 1.839844 "/>
                      </g>
                      </svg>
                        <p class="margin-0">More</p>
                    </button>
                     <el-popover
                      id="popoverBottom"
                      ref="popover"
                      popper-class="popover"
                      placement="top"
                      width="150"
                      trigger="click"
                      visible-arrow= "false"
                    >
                      <div class="popover-body">
                       <div class= "pop-link" @click="popMenu('ourFarms')">
                          <b-icon icon="file-text"></b-icon>
                          <span>Our Farms</span>
                        </div>
                        <div class= "pop-link" @click="()=>popMenu('aboutUs')">
                          <b-icon icon="file-text"></b-icon>
                          <span>About Us</span>
                        </div>
                        <!--div class= "pop-link" @click="()=>popMenu('contactUs')">
                          <b-icon icon="file-text"></b-icon>
                          <span>Contact Us</span>
                        </div-->
                      </div>
                    </el-popover>
                </div>
            </div>
        </section>
  </div>
</template>
  </footer>
</template>

<script>
import { Popover } from 'element-ui';
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  components: {
    [Popover.name]: Popover
  },
  mounted () {
    //alert("mounted")
    //window.addEventListener('scroll', this.onScroll)
  },
   beforeDestroy () {
   // window.removeEventListener('scroll', this.onScroll)
  }, 
  created(){
   //alert("created")
  },
  data() {
    return {
      //bgImage: 'img/footer.png',
      year: new Date().getFullYear(),
      showNavbar: this.$route.path === '/trialOffer' ? false: true,
      lastScrollPosition: 0,
      bottomNavClicked: false,
      showBottomNavbar: true,
      scrolledToBottom: false
    };
  },
  methods: {
    popMenu(page){
      document.getElementsByClassName('popover')[0].style.display = 'none';
      this.$router.push(page)
    },
    showBottomMenu(){
      var bottomMenu = document.getElementById('sm_bottom_menu');
      if (bottomMenu.classList.contains('hidebottomMenuBtn')) {
        this.showNavbar = true
        document.getElementById('sm_bottom_menu').style.top = '-40px'
        this.bottomNavClicked = false
        
      } else {
        if(this.bottomNavClicked == false){
          this.showNavbar = false
          document.getElementById('sm_bottom_menu').style.top = '-80px'
          this.bottomNavClicked = true
          //document.getElementById('sm_bottom_menu').style.bottom = '0'
        }else{
          this.showNavbar = true
          document.getElementById('sm_bottom_menu').style.top = '-40px'
          this.bottomNavClicked = false
        // document.getElementById('sm_bottom_menu').style.bottom = 'auto'
        }
      }
    },
    onScroll () {
      if(!this.bottomNavClicked){
        // Get the current scroll position
        var appDiv = document.getElementById("app");
        const currentScrollPosition = window.pageYOffset || appDiv.scrollTop
        // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
        //alert(currentScrollPosition)

        if (currentScrollPosition < 0) {
          return
        }
        // Here we determine whether we need to show or hide the navbar
        this.showNavbar = currentScrollPosition < this.lastScrollPosition
        //alert(this.showNavbar)
        if(this.showNavbar){
          document.getElementById('sm_bottom_menu').style.top = '-40px'
          //document.getElementById('sm_bottom_menu').style.bottom = 'auto'
        }else{
          document.getElementById('sm_bottom_menu').style.top = '-80px'
         // document.getElementById('sm_bottom_menu').style.bottom = '0'
        }
        // Set the current scroll position as the last scroll position
        this.lastScrollPosition = currentScrollPosition 
      }

     /*  let bottomOfWindow = Math.max(window.pageYOffset, appDiv.scrollTop, document.body.scrollTop) + window.innerHeight === appDiv.offsetHeight
      //alert(bottomOfWindow)
      if (bottomOfWindow) {
        //if(this.bottomNavClicked)
        this.showNavbar = false
        //this.bottomNavClicked = !this.bottomNavClicked
        this.showBottomNavbar = true
      } 
      else{
        //this.showNavbar = false
        //this.bottomNavClicked = !this.bottomNavClicked
        this.showBottomNavbar = false
      } */
    }
  }
};
</script>
<style>


</style>
